import {
  SET_TRACKS,
  DELETE_TRACKS,
  RENAME_TRACK,
  LIKE_TRACK,
  UNLIKE_TRACK
} from "@/store/mutation-types";

export default {
  [SET_TRACKS](state, tracks) {
    state.tracks = {
      ...state.tracks,
      ...tracks.reduce((map, track) => ({ ...map, [track.id]: track }), {})
    };
  },
  [DELETE_TRACKS](state, tracksIds = []) {
    const newState = { ...state.tracks };

    tracksIds.forEach(trackId => {
      if (state.tracks[trackId]) {
        delete newState[trackId];
      }
    });

    state.tracks = { ...newState };
  },
  [RENAME_TRACK](state, { id, title }) {
    state.tracks = {
      ...state.tracks,
      [id]: {
        ...state.tracks[id],
        name: title
      }
    };
  },
  [LIKE_TRACK](state, id) {
    state.tracks[id].likes.liked = true;
    state.tracks[id].likes.count += 1;
  },
  [UNLIKE_TRACK](state, id) {
    state.tracks[id].likes.liked = false;
    state.tracks[id].likes.count -= 1;

    if (state.tracks[id].likes.count < 0) {
      state.tracks[id].likes.count = 0;
    }
  }
};
